import { Component, ContentChild, Input, OnInit, ViewChild } from '@angular/core';
import { EventTransportService } from '../../services/event-transport/event-transport.service';

@Component({
    selector: 'app-copy',
    templateUrl: './copy.component.html',
    styleUrls: ['./copy.component.scss']
})
export class CopyComponent implements OnInit
{
    @Input() value: string = '';
    @ViewChild('inputCopy') inputCopy;
    @ContentChild('ref') ref;

    constructor(
        private eventTransport: EventTransportService
    ) { }

    ngOnInit(): void
    {
    }

    public async copyValue(e:Event)
    {
        e.preventDefault();
        e.stopImmediatePropagation();

        //this.inputCopy.nativeElement.select();
        //this.inputCopy.nativeElement.setSelectionRange(0, 99999);

        try
        {
            await navigator.clipboard.writeText(this.value);
            this.eventTransport.send('toast', { message: 'COMMON.COPIED', icon: false });
        }
        catch (e)
        {
            //this.eventTransport.send('toast', {message: 'COMMON.COPIED'});
        }
    }
}
